<template>
    <div class="body-inner">
        <header-component></header-component>
        <!-- SHOP CHECKOUT -->
        <section id="shop-checkout" class="no-padding-top">
            <div class="container">
                <div class="shop-cart" v-if="$store.getters.productos.length">
                    <div class="seperator"><i class="fa fa-credit-card"></i></div>
                    <div class="row">
                        <div class="col-lg-8">
                            <h4 class="upper">Tu pedido</h4>
                            <div class="table table-sm table-striped table-responsive table table-bordered table-responsive">
                                <table class="table m-b-0">
                                    <thead>
                                        <tr>
                                            <th class="cart-product-thumbnail">Producto</th>
                                            <th class="cart-product-name">Descripción</th>
                                            <th class="cart-product-name">Cantidad</th>
                                            <th class="cart-product-subtotal">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="producto in productos">
                                            <tr v-for="version in producto.versiones" :key="version.id">
                                                <td class="cart-product-thumbnail">
                                                    <div class="cart-product-thumbnail-name">{{ version.nombre }}</div>
                                                </td>
                                                <td class="cart-product-description">
                                                    <p>{{ version.tipoCompra }}</p>
                                                </td>
                                                <td class="cart-product-description">
                                                    <p>{{ version.cantidad }} X {{ version.precio.toFixed(2) }}</p>
                                                </td>
                                                <td class="cart-product-subtotal">
                                                    <span class="amount">${{ version.subtotal.toFixed(2) }}</span>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                            <div id="card-wrapper" class='card-wrapper' v-show="tipoPago > 0 && tipoPago == 1"></div>
                            <vue-form :state="formstate" @submit.prevent="procesarPagoTC" id="formCard" v-show="tipoPago > 0 && tipoPago == 1">
                                <div class="row">
                                    <div class="col-sm-12 mt-3 ">
                                        <div class="form-group">
                                            <validate tag="div">
                                                <input v-model="model.cardNumber" name="cardnumber" id="cardnumber" type="text" required autofocus placeholder="Número de tarjeta" class="form-control"/>
                                                <field-messages name="cardnumber" show="$invalid && $submitted" class="text-danger">
                                                    <div slot="required">El número de tarjeta es requerido</div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <validate tag="div">
                                                <input v-model="model.cardExpiry" name="cardexpiry" id="cardexpiry" type="text" required placeholder="MM/YYYY" class="form-control" />
                                                <field-messages name="cardexpiry" show="$invalid && $submitted" class="text-danger">
                                                    <div slot="required">La fecha de expiración es requerida</div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <validate tag="div">
                                                <input v-model="model.cardCvc" name="cardcvc" id="cardcvc" type="text" required placeholder="Código de seguridad" class="form-control" />
                                                <field-messages name="cardcvc" show="$invalid && $submitted" class="text-danger">
                                                    <div slot="required">El código de seguridad es requerido</div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <validate tag="div">
                                                <input v-model="model.cardHolder" name="cardname" id="cardname" type="text" required placeholder="Nombre del Titular (Como aparece en la tarjeta)" class="form-control"  />
                                                <field-messages name="cardname" show="$invalid && $submitted" class="text-danger">
                                                    <div slot="required">El titular de la tarjeta es requerido</div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <input type="submit" value="Procesar pago" class="btn btn-warning btn-block mb-3"/>
                                    </div>
                                </div>
                            </vue-form>
                        </div>
                        <div class="col-lg-4">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="table-responsive">
                                        <h4>Total del pedido</h4>
                                        <table class="table">
                                            <tbody>
                                                <tr>
                                                    <td class="cart-product-name">
                                                        <strong>Total</strong>
                                                    </td>
                                                    <td class="cart-product-name text-right">
                                                        <span class="amount color lead"><strong>${{ $store.getters.total.toFixed(2) }}</strong></span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <h4 class="upper">Seleccionar método de pago</h4>
                                    <div class="list-group">
                                        <input type="radio" name="radioPagar" value="1" id="radioTarjeta" v-model="tipoPago"/>
                                        <label class="list-group-item" for="radioTarjeta"><img width="90" alt="paypal" src="images/visa-mastercard.png"> <small>Pago con tarjeta</small></label>
                                        <input type="radio" name="radioPagar" value="2" id="radioOxxo" v-model="tipoPago"/>
                                        <label class="list-group-item" for="radioOxxo"><img width="90" alt="paypal" src="images/oxxo-pay.png"> <small>Depósito en Oxxo</small></label>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <button class="btn icon-left float-right mt-3" href="#" v-if="tipoPago > 0 && tipoPago == 2" @click="procesarPago"><span>Generar ficha de pago</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Footer -->
        <footer id="footer">
            <div class="copyright-content">
                <div class="container">
                    <div class="copyright-text text-center">&copy; 2020 <a href="https://etciberoamerica.com/" target="_blank" rel="noopener">ETC IBEROAMÉRICA.</a> </div>
                </div>
            </div>
        </footer>
        <!-- end: Footer -->
    </div>
</template>

<script>
/* eslint-disable */
import Card from 'card'
import HeaderComponent from './components/HeaderComponent'
import options from "../validations/validations.js";
Vue.use(VueForm, options);
export default {
  name: 'Checkout',
  components: {
    HeaderComponent
  },
  data() {
        return {
            formstate: {},
            model: {
                cardHolder: '',
                cardNumber: '',
                cardExpiry: '',
                cardCvc: '',
                phone: '',
            },
            total: 0,
            tipoPago: 0,
            productos: [],
            apiConekta: '',
            tipoRegistro: '',
            hostname: '',
        }
  },

  methods: {

    async procesarPago() {
        if(this.$store.getters.total <= 10000) {
            await this.saveDataNoForm('api/ordenes', { productos: this.productos, tipoPago: this.tipoPago, tipoRegistro: this.tipoRegistro, total: this.$store.getters.total, cupon: this.$store.getters.cupon }, '', '', null, 0, 1, null)
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Para compras mayores a $10,000 MXN debes de usar el pago con tarjeta.',
            })
        }
    },

    procesarPagoTC() {
        if (this.formstate.$invalid) {
            return;
        } else {
            this.openLoading()
            window.Conekta.setPublicKey(this.apiConekta)
            let expiry = this.model.cardExpiry.split(' / ')
            const tokenParams = {
                card: {
                    number: this.model.cardNumber,
                    name: this.model.cardHolder,
                    exp_year: expiry[1],
                    exp_month: expiry[0],
                    cvc: this.model.cardCvc
                }
            }
            window.Conekta.Token.create(tokenParams, async token => {
                await this.saveDataNoForm('api/ordenes', { productos: this.productos, tipoPago: this.tipoPago, token, tipoRegistro: this.tipoRegistro, total: this.$store.getters.total, cupon: this.$store.getters.cupon }, '/compras', '', null, 0, 1, null)
            }, error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: error.message_to_purchaser,
                })
            })
        }
    },

    async procesaPagoBanorte() {
        /*let xObjEnc

        if(Payment) {
            Payment.setEnv('pro')

            setTimeout(() => {
                xObjEnc = Payment.encrypt({
                    params: {
                        MerchantID:8400899,
                        User: 'a8400899',
                        Password: '$3TC1b3r0am$',
                        Mode: 'AUT',
                        ControlNumber: '12345678',
                        TerminalID: '84008991',
                        Amount: 1000,
                        MerchantName: 'ETCIBEROAMERICA',
                        MerchantCity: 'Metepec',
                        Language: 'ES',
                        FirstName: 'Juan Francisco',
                        LastName: 'Estrada Garfias',
                        Street: 'Prueba',
                        StreetNumberExt: '1',
                        Col: 'Centro',
                        Del: 'Metepec',
                        City: 'Metepec',
                        State: 'MC',
                        Country: 'MX',
                        PhoneNumber: '7222531814',
                        PostalCode: '52169',
                        Email: 'francisco.estrada@etciberoamerica.com',
                    }
                })
        
                Payment.startPayment({
                    params: {
                        crypt: xObjEnc
                    },
                    onError: (response) => {
                        console.log(response)
                    }
                })
            }, 1000);
        }*/
    }
  },
  async mounted() {
    const scriptPagina = document.createElement('script')
    scriptPagina.src = 'js/functions.js'
    scriptPagina.id = 'functionScript'
    document.body.appendChild(scriptPagina)

    this.apiConekta = apiConekta
    this.hostname = hostname

    if(this.hostname == 'innovaccion.etciberoamerica.com')
        this.tipoRegistro = 'innovaccion'
    if(this.hostname == 'store.etciberoamerica.com')
        this.tipoRegistro = 'etc'
    if(this.hostname == 'storebpo.etciberoamerica.com')
        this.tipoRegistro = 'bpo'

    //conekta
    const script = document.createElement('script')
    script.src = 'https://cdn.conekta.io/js/latest/conekta.js'
    script.async = true
    document.body.appendChild(script)

    /*const scriptBanorte = document.createElement('script')
    scriptBanorte.src = 'https://cib.banorte.com/orquestador/lightbox/checkout.js'
    scriptBanorte.async = true
    document.body.appendChild(scriptBanorte)*/

    //card
    var card = new Card({
        form: '#formCard',
        container: '#card-wrapper',
        width: 300, // optional — default 350px
        formatting: true, // optional - default true
        // Strings for translation - optional
        messages: {
            validDate: 'valid\ndate', // optional - default 'valid\nthru'
            monthYear: 'mm/yyyy', // optional - default 'month/year'
        },
        // Default placeholders for rendered fields - optional
        placeholders: {
            number: '•••• •••• •••• ••••',
            name: 'Titular',
            expiry: '••/••',
            cvc: '•••'
        },
        formSelectors: {
            numberInput: 'input[name="cardnumber"]', // optional — default input[name="number"]
            expiryInput: 'input[name="cardexpiry"]', // optional — default input[name="expiry"]
            cvcInput: 'input[name="cardcvc"]', // optional — default input[name="cvc"]
            nameInput: 'input[name="cardname"]' // optional - defaults input[name="name"]
        },
        masks: {
            cardNumber: '•'
        }
    })

    //ejecutamos el script de banorte
  },
  beforeCreate() {
      
    //Payment.setEnv("dev");
  },
    beforeDestroy() {
        const scriptElem = document.getElementById('functionScript'); 
        scriptElem.remove()
    }
}
</script>
